import { Job } from 'lib/types/jobs';
import { A } from 'components/A';
import { SimpleJobCard } from 'components/JobCard';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { useState, useEffect } from 'react';

interface Props {
  serverSideJobs?: Job[];
}

export const JobsModule = ({ serverSideJobs }: Props) => {
  const API = useApi();
  const currentUser = useCurrentUser();
  const [jobs, setJobs] = useState<Job[] | undefined>(serverSideJobs);

  useEffect(() => {
    const getJobs = async () => {
      try {
        const response = await API.getFeaturedJobs({});
        setJobs(response);
      } catch (err) {
        // noop
      }
    };

    if (!jobs) {
      getJobs();
    }
  }, [currentUser, API]);

  if (!jobs || !jobs.length) {
    return null;
  }

  return (
    <div className="max-w-screen-xl m-auto p-4">
      <div className="flex justify-between mb-2 flex-wrap">
        <h3 className="font-extrabold text-2xl mb-1" suppressHydrationWarning>Latest Jobs On Gondola</h3>
        <div>
          <A
            href="/jobs"
            className="underline text-lg"
          >
            More jobs
          </A>
        </div>
      </div>
      <div className="grid grid-flow-row grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {jobs.map((job: Job) => (
          <SimpleJobCard
            job={job}
            account={job.account}
            key={job.id}
          />
        ))}
      </div>
    </div>
  );
};
